import { createOrbitBridgeClient } from "@tuxx/orbit-bridge";
import type { OrbitClient, OrbitClientConfig } from "./types";

/**
 * Create an Orbit embed client. All widget API calls go through this
 * single entry point so host apps only wire up one thing.
 */
export function createOrbitClient(config: OrbitClientConfig): OrbitClient {
  const bridge = createOrbitBridgeClient(config);

  return {
    call: bridge.call,
    whoami: bridge.whoami,
    track: bridge.track,
    attachments: bridge.attachments,
    billing: bridge.billing,
    commands: bridge.commands,
    requests: bridge.requests,
    reports: bridge.reports,
  };
}
